interface TitlePageProps {
    title: string;
}

const TitlePage = ({ title }: TitlePageProps) => {
    return (
        <div className='container section-title' data-aos='fade-up'>
            <h2>{title}</h2>
        </div>
    );
};
export default TitlePage;
